export const victoryMessages = [
  'final.victory.message1',
  'final.victory.message2',
  'final.victory.message3',
  'final.victory.message4',
  'final.victory.message5',
  'final.victory.message6',
  'final.victory.message7',
  'final.victory.message8',
  'final.victory.message9',
  'final.victory.message10',
];

export const defeatMessages = [
  'final.defeat.message1',
  'final.defeat.message2',
  'final.defeat.message3',
  'final.defeat.message4',
  'final.defeat.message5',
  'final.defeat.message6',
  'final.defeat.message7',
  'final.defeat.message8',
  'final.defeat.message9',
  'final.defeat.message10',
];
